import React, {Component} from 'react';
import UpcomingContent from '../function-components/UpcomingContent'

function Upcoming() {
    return(
        <>
            <UpcomingContent />
        </>
    );
   }

export default Upcoming;